import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  //  p: 4,
  outline: "none",
};

const Attachments = ({ open, setOpen }) => {
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      onClose={handleClose}
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "10px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Attachments
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "15px",
            }}
          >
            <Typography sx={{ fontSize: "15px" }}>Attachment Type</Typography>
            <Box sx={{ flex: 1, ml: 10 }}>
              <TextField size="small" fullWidth></TextField>
              <span sx={{ fontSize: "12px", marginLeft: "10px" }}>
                <Typography
                  sx={{
                    marginTop: "5px",
                    marginLeft: "10px",
                    fontSize: "13px",
                    color: "red",
                  }}
                >
                  (Only .pdf,.png,.jpeg,.doc,.xls file to be attached)
                </Typography>
              </span>
            </Box>
            <Box>
              <Button
                variant="contained"
                sx={{ fontSize: "12px", height: 40, ml: 1 }}
                component="label"
              >
                Browse
                <input hidden multiple type="file" />
              </Button>
            </Box>
          </Box>
          <Box sx={{ padding: "0px 15px" }}>
            <Button>Add more</Button>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleClose}
              variant="contained"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Attach
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default Attachments;
